// extracted by mini-css-extract-plugin
export var active = "_fi-2";
export var recordingDot = "_fi-1";
export var recordingIndicator = "_fi-0";